/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CreateScheduledTransferLineItem,
  CreateScheduledTransferLineItem$inboundSchema,
  CreateScheduledTransferLineItem$Outbound,
  CreateScheduledTransferLineItem$outboundSchema,
} from "./createscheduledtransferlineitem.js";

/**
 * An optional collection of line items for a scheduled transfer.
 *
 * @remarks
 * When line items are provided their total must equal `amount` minus `salesTaxAmount`.
 */
export type CreateScheduledTransferLineItems = {
  /**
   * The list of line items.
   */
  items: Array<CreateScheduledTransferLineItem>;
};

/** @internal */
export const CreateScheduledTransferLineItems$inboundSchema: z.ZodType<
  CreateScheduledTransferLineItems,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(CreateScheduledTransferLineItem$inboundSchema),
});
/** @internal */
export type CreateScheduledTransferLineItems$Outbound = {
  items: Array<CreateScheduledTransferLineItem$Outbound>;
};

/** @internal */
export const CreateScheduledTransferLineItems$outboundSchema: z.ZodType<
  CreateScheduledTransferLineItems$Outbound,
  z.ZodTypeDef,
  CreateScheduledTransferLineItems
> = z.object({
  items: z.array(CreateScheduledTransferLineItem$outboundSchema),
});

export function createScheduledTransferLineItemsToJSON(
  createScheduledTransferLineItems: CreateScheduledTransferLineItems,
): string {
  return JSON.stringify(
    CreateScheduledTransferLineItems$outboundSchema.parse(
      createScheduledTransferLineItems,
    ),
  );
}
export function createScheduledTransferLineItemsFromJSON(
  jsonString: string,
): SafeParseResult<CreateScheduledTransferLineItems, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateScheduledTransferLineItems$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateScheduledTransferLineItems' from JSON`,
  );
}
